'use strict';

const bannerTokens = (theme) => ({
    bannerCloseIconColor: theme.palette.grey500,
    bannerCloseIconFontSize: theme.typography.fontSize.s,
    bannerCloseIconPaddingX: theme.space.component.x.m,
    bannerCloseIconPaddingY: theme.space.component.y.m,
});

exports.bannerTokens = bannerTokens;
//# sourceMappingURL=banner.js.map
